document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll(".tabs-wrapper .tab");
  const contents = document.querySelectorAll(".tabs-wrapper .content_wrapper");

  if (tabs.length > 0 && contents.length > 0) {
    // Get the first unique data-tab value
    const firstTabValue = tabs[0].getAttribute("data-tab");

    // Set the first tab and corresponding content as active
    tabs.forEach(tab => {
      if (tab.getAttribute("data-tab") === firstTabValue) {
        tab.classList.add("active");
      }
    });

    contents.forEach(content => {
      if (content.getAttribute("data-tab") === firstTabValue) {
        content.classList.add("active");
      }
    });

    // Add click event to tabs
    tabs.forEach((tab) => {
      tab.addEventListener("click", function () {
        const tabValue = this.getAttribute("data-tab");

        // Remove active class from all tabs and contents
        tabs.forEach((t) => t.classList.remove("active"));
        contents.forEach((c) => c.classList.remove("active"));

        // Add active class to the clicked tab and its matching content
        tabs.forEach((t) => {
          if (t.getAttribute("data-tab") === tabValue) {
            t.classList.add("active");
          }
        });

        contents.forEach((content) => {
          if (content.getAttribute("data-tab") === tabValue) {
            content.classList.add("active");
          }
        });
      });
    });
  }
});
